import React from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Metrological_traceability_Form from "./metrological_traceability_Form/Metrological_traceability_Form";
import Metrological_traceability_table from "./metrological_traceability_table/Metrological_traceability_table";

function Metrological_traceability() {
  return (
    <>
      <section className="Imperiality Quality_Policy ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="Metrological Traceability" />
        </div>
        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
            All measurements performed in the laboratory are traceable to national or international standards through an unbroken chain of calibrations. Each calibration is supported by valid certificates indicating measurement uncertainty and reference standards used. This ensures the reliability, accuracy, and global comparability of test results in compliance with ISO/IEC 17025:2017 requirements 
            </p>
          </div>
        </div>

        <div className="imperiality_Form_div">
          <Metrological_traceability_Form />
        </div>

        <div className="imperiality_table_div">
          <Metrological_traceability_table />
        </div>

       
      </section>
    </>
  );
}

export default Metrological_traceability;
